export default "__VITE_ASSET__fa85083c__"